import Vue from 'vue'

let Raven = null

if (process.env.SENTRY_DSN_PUBLIC) {
  Raven = require('raven-js')
  let RavenVue = require('raven-js/plugins/vue')

  Raven.config(process.env.SENTRY_DSN_PUBLIC)
  Raven.addPlugin(RavenVue, Vue)

  if (window.env && window.env.RELEASE) {
    Raven.setRelease(window.env.RELEASE)
  }
  if (window.env && window.env.APP_ENV) {
    Raven.setEnvironment(window.env.APP_ENV)
  }

  Raven.install()
}

export default Raven



// WEBPACK FOOTER //
// ./resources/assets/js/raven.js